// Client-side achievement registry — labels + Norse lore for the tooltip
// popovers on the Trophy Wall, plus a compact `<AchievementBadges>`
// component reused by ReviewCard, KnownIssuesSection, and the profile.
import React from "react";
import { RavenIcon, SkaldIcon, WatchmanIcon, TrailScoutIcon, MasterScoutIcon } from "../components/AchievementIcons";

export const ACHIEVEMENTS = {
  messenger: {
    key: "messenger",
    name: "The Messenger",
    Icon: RavenIcon,
    lore: "The Messenger: Awarded for reporting your first trail hazard. Like Odin's ravens, you bring news of the wild.",
  },
  skald: {
    key: "skald",
    name: "The Skald",
    Icon: SkaldIcon,
    lore: "The Skald: Awarded for leaving your first trail review. You are the storyteller of the pack.",
  },
  watchman: {
    key: "watchman",
    name: "The Watchman",
    Icon: WatchmanIcon,
    lore: "The Watchman: Awarded when three fellow walkers confirm a hazard you reported. Your keen eye guards the pack.",
  },
  trail_scout: {
    key: "trail_scout",
    name: "The Trail Scout",
    Icon: TrailScoutIcon,
    lore: "The Trail Scout: Awarded for verifying five Scout Needed trails. Five paths now bear your rune.",
  },
  master_scout: {
    key: "master_scout",
    name: "The Master Scout",
    Icon: MasterScoutIcon,
    lore: "The Master Scout: Awarded for verifying twenty-five Scout Needed trails. A rune-crown of paths only the elders wear.",
  },
};

export const ALL_ACHIEVEMENT_KEYS = Object.keys(ACHIEVEMENTS);

// Small inline row of earned-only badges — used next to author names in
// ReviewCard / KnownIssuesSection.
export function AchievementBadges({ keys, size = 14, className = "" }) {
  if (!Array.isArray(keys) || keys.length === 0) return null;
  return (
    <span
      data-testid="achievement-badges"
      className={`inline-flex items-center gap-1 text-brand-primary ${className}`}
    >
      {keys.map((k) => {
        const meta = ACHIEVEMENTS[k];
        if (!meta) return null;
        const { Icon, name } = meta;
        return (
          <Icon
            key={k}
            size={size}
            className="shrink-0"
            data-testid={`achievement-badge-${k}`}
            aria-label={name}
          />
        );
      })}
    </span>
  );
}

// Formats the author display line: "Shared by [User] & [Dog]" when a
// dog_name is present, otherwise "Shared by [User]" (or the fallback).
export function formatAuthorLine(userName, dogName, fallback = "A walker") {
  const u = (userName || "").trim() || fallback;
  const d = (dogName || "").trim();
  return d ? `Shared by ${u} & ${d}` : `Shared by ${u}`;
}
